export default __webpack_public_path__ + "static/media/slideshow_step2_fr.afd04282.png";